<template>
  <div>
    <b-alert :show="error && error.length ? true : false" variant="danger">
      <div v-if="Array.isArray(error)">
        <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
          {{ error_text }}
        </div>
      </div>
      <div v-else>
        <div v-html="error || '&nbsp;'"></div>
      </div>
    </b-alert>
    <div
      class="trip-title mb-3 mt-3"
      id="edit-trip-form-label-from-reservation"
      v-if="tripID && payload?.reservation?.id"
    >
      {{
        $t('journey-reservation-id', {
          id: tripID,
          reservationId: payload.blanketOrder?._id,
        })
      }}
    </div>
    <div
      class="trip-title mb-3 mt-3"
      id="edit-trip-form-label-from-reservation"
      v-else-if="tripID && payload?.contract?.id"
    >
      {{
        $t('journey-contract-id', {
          id: tripID,
          contractId: payload.contract.id,
        })
      }}
    </div>
    <div class="block mb-3">
      <div v-if="labelText" class="title mb-3">
        {{ labelText }}
      </div>
      <div
        class="row"
        v-if="!$store.getters['enums/is_not_permitted']('editTripLocationByOperator')"
      >
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-input
            id="edit-trip-form-pick-up-location"
            name="pick up location"
            rules="required"
            :is_required="true"
            label="pick-up-location"
            placeholder="add-location"
            cus_style="padding:10px 10px 10px 30px;cursor: pointer;"
            :value="payload?.start?.name"
            @click="toggleLocationPicker('Set pickup location', 'start')"
            :disabled="loading || true"
            readOnly
          >
            <template v-slot:attachment>
              <div class="location-prefix">
                <img
                  v-if="payload?.start?.name"
                  src="@/assets/images/icons/placeholder-location.svg"
                  alt="placeholder-location"
                />
                <img v-else src="@/assets/images/icons/placeholder-add.svg" alt="placeholder-add" />
              </div>
            </template>
          </base-input>
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-input
            id="edit-trip-form-drop-off-location"
            label="drop-off-location-optional"
            placeholder="add-location"
            cus_style="padding:10px 10px 10px 30px;cursor: pointer;"
            @click="toggleLocationPicker('Set Dropoff location', 'end')"
            :value="payload?.end?.name"
            :disabled="loading || !payload.start"
            readOnly
          >
            <template v-slot:attachment>
              <div class="location-prefix">
                <img
                  v-if="payload?.end?.name"
                  src="@/assets/images/icons/placeholder-location.svg"
                  alt="placeholder-location"
                />
                <img v-else src="@/assets/images/icons/placeholder-add.svg" alt="placeholder-add" />
              </div>
            </template>
          </base-input>
        </div>
      </div>

      <div
        class="row"
        v-if="!this.$store.getters['enums/is_not_permitted']('editTripDateAndTimeByOperator')"
      >
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-date-time-picker
            id="edit-trip-from-date"
            name="from date"
            rules="required"
            label="from-date"
            :is_required="true"
            :timePicker="true"
            date_field="from_date"
            time_field="from_time"
            :value="payload"
            :minDate="new Date()"
            @change-value="
              (date_value, date_field, time_value, time_field) => {
                setValue(date_value, date_field)
                setValue(time_value, time_field)
              }
            "
            :disabled="loading || isDateEditDisabled"
            :readOnly="isDateEditDisabled"
            :helper_text="
              isDateEditDisabled
                ? ''
                : !validFromDate
                ? $t('invalid-value-of-from-date')
                : !validFromTime
                ? $t('invalid-value-time')
                : ''
            "
            :is_invalid="isDateEditDisabled ? false : !validFromDate || !validFromTime"
            helper_text_style="color:var(--color-47);"
          ></base-date-time-picker>
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-date-time-picker
            id="edit-trip-to-date"
            name="to date"
            :rules="toDateRules"
            label="to-date"
            :is_required="true"
            :timePicker="true"
            date_field="to_date"
            time_field="to_time"
            :value="payload"
            :minDate="new Date(payload.from_date)"
            @change-value="
              (date_value, date_field, time_value, time_field) => {
                setValue(date_value, date_field)
                setValue(time_value, time_field)
              }
            "
            :disabled="loading || !payload.from_date || isDateEditDisabled"
            :readOnly="isDateEditDisabled"
            :helper_text="
              isDateEditDisabled
                ? ''
                : !validToDate
                ? $t('invalid-value-of-to-date')
                : !validToTime
                ? $t('invalid-value-time')
                : ''
            "
            :is_invalid="isDateEditDisabled ? false : !validToDate || !validToTime"
            helper_text_style="color:var(--color-47);"
          ></base-date-time-picker>
        </div>
      </div>
      <div class="row">
        <div
          class="col-lg-6 col-md-9 col-sm-12"
          v-if="!$store.getters['enums/is_not_permitted']('editTripLocationByOperator')"
        >
          <base-select
            id="edit-trip-form-branch"
            name="branch"
            rules="required"
            label="branch"
            :is_required="true"
            :options="$store.getters['enums/branch_enums']"
            field="branch"
            :value="payload.branch"
            @change-value="setValue"
            :disabled="loading || disabledBranch || true"
          />
          <!-- <div v-if="disabledBranch" class="label mb-3">
            <span class="error">{{ $t("edit-branch-message-err") }}</span>
          </div> -->
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-select
            id="edit-trip-form-branch"
            name="zone"
            rules="required"
            label="zone"
            :is_required="true"
            :options="$store.getters['enums/zone_enums']"
            field="zone"
            :value="payload.zone"
            @change-value="setValue"
            :disabled="true"
          />
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-select
            :key="payload.branch"
            name="garage"
            rules="required"
            label="garage"
            :is_required="true"
            :options="garageOptions"
            field="garage"
            :value="payload.garage"
            @change-value="setValue"
            :disabled="loading"
          />
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <base-select
            :key="payload.branch + '-' + waterSourceOptions.length"
            id="edit-trip-form-water-source"
            name="water-source"
            rules="required"
            label="water-source"
            :is_required="true"
            field="waterSource"
            :options="waterSourceOptions"
            :value="payload.waterSource"
            @change-value="setValue"
          />
        </div>
      </div>
    </div>
    <location-picker
      :show_picker="show_picker"
      :title="location_title"
      :field="location_field"
      :payload="payload"
      @toggleLocationPicker="toggleLocationPicker"
      @setMarker="setMarker"
    />
  </div>
</template>

<script>
import BranchService from '@/services/branch.service'
import LocationPicker from './LocationPicker.vue'
import branchService from '@/services/branch.service'
import WaterSourceService from '@/services/water-source.service'

export default {
  name: 'edit-trip',
  components: { LocationPicker },
  props: [
    'payload',
    'loading',
    'validFromDate',
    'validToDate',
    'validFromTime',
    'validToTime',
    'tripID',
    'disabledBranch',
    'status',
    'isDateEditDisabled',
  ],
  data() {
    return {
      show_picker: false,
      location_title: '',
      location_field: '',
      error: null,
      garageOptions: [{ value: null, text: 'select-an-option' }],
      isPrefilling: false,
      waterSources: [{ value: null, text: 'select-an-option' }],
    }
  },
  methods: {
    getGarageOptions(branchId) {
      return new Promise((resolve) => {
        let params = { active: true, select: '_id,name,arabicName', limit: 100000000 }

        BranchService.get(`${branchId}/garages`, params)
          .then(({ items }) => {
            const garages = (items || []).map((each) => ({
              value: String(each._id),
              text: this.isLangRtl ? each.arabicName : each.name,
            }))

            this.garageOptions = garages
            resolve()
          })
          .catch((err) => {
            this.garageOptions = [{ value: null, text: 'no-options-available' }]
            resolve()
          })
      })
    },
    getwaterSourceOptions(branchId) {
      return new Promise((resolve) => {
        let params = { active: true, select: '_id,name,arabicName', limit: 10000000000 }

        BranchService.get(`${branchId}/water-sources`, params)
          .then(({ items }) => {
            const waterSources = (items || []).map((each) => ({
              value: String(each._id),
              text: this.isLangRtl ? each.arabicName : each.name,
            }))

            const currentWaterSourceId = this.payload.waterSource?._id
              ? String(this.payload.waterSource._id)
              : this.payload.waterSource
              ? String(this.payload.waterSource)
              : null

            const foundInActiveList = waterSources.some(
              (each) => each.value === currentWaterSourceId
            )

            console.log('[SFMS-1516][getwaterSourceOptions] branchId:', branchId, {
              tripId: this.tripID,
              currentWaterSourceId,
              activeWaterSourceIds: waterSources.map((each) => each.value),
              foundInActiveList,
            })

            // The trip's already-assigned water source may since have been deactivated,
            // so it won't be in the active-only list above. Fetch it directly so old trips
            // still show/keep their assigned value instead of losing it.
            if (currentWaterSourceId && !foundInActiveList) {
              console.log(
                '[SFMS-1516][getwaterSourceOptions] not found in active list, fetching by id:',
                currentWaterSourceId
              )
              WaterSourceService.get(currentWaterSourceId)
                .then((waterSource) => {
                  console.log(
                    '[SFMS-1516][getwaterSourceOptions] fallback fetch result:',
                    waterSource
                  )
                  if (waterSource) {
                    waterSources.push({
                      value: String(waterSource._id),
                      text: this.isLangRtl ? waterSource.arabicName : waterSource.name,
                    })
                  }
                })
                .catch((err) => {
                  console.log(
                    '[SFMS-1516][getwaterSourceOptions] fallback fetch failed (deleted or inaccessible):',
                    err
                  )
                })
                .finally(() => {
                  this.waterSources = waterSources
                  resolve()
                })
            } else {
              this.waterSources = waterSources
              resolve()
            }
          })
          .catch((err) => {
            console.log('[SFMS-1516][getwaterSourceOptions] branch water-sources fetch failed:', err)
            this.waterSources = [{ value: null, text: 'no-options-available' }]
            resolve()
          })
      })
    },

    setMarker(location, name) {
      this['payload'][this.location_field] = {
        location,
        name,
      }
    },

    async prefillZoneAndGarage() {
      const targetGarageId = this.payload.garage?._id
        ? String(this.payload.garage._id)
        : this.payload.garage
        ? String(this.payload.garage)
        : null

      const targetWaterSourceId = this.payload.waterSource?._id
        ? String(this.payload.waterSource._id)
        : this.payload.waterSource
        ? String(this.payload.waterSource)
        : null

      const targetStart = this.payload.start

      const zoneId = this.payload.zone || this.payload?.reservation?.zone?._id
      if (!zoneId) return

      console.log('[SFMS-1516][prefillZoneAndGarage] start:', {
        tripId: this.tripID,
        targetGarageId,
        targetWaterSourceId,
        targetStart,
      })

      this.isPrefilling = true

      try {
        if (!this.payload.zone && zoneId) {
          this.payload.zone = zoneId
        }

        await Promise.all([
          this.getGarageOptions(this.payload.branch),
          this.getwaterSourceOptions(this.payload.branch),
        ])

        await this.$nextTick()

        const waterSourceRestored =
          targetWaterSourceId &&
          this.waterSources.some((w) => String(w.value) === targetWaterSourceId)

        if (waterSourceRestored) {
          this.payload.waterSource = targetWaterSourceId
        }

        // The trip's already-saved pickup location gets wiped as a side effect of the
        // water-source dropdown briefly not matching any option while options are loading
        // (see setValue()'s `else if (field === 'waterSource' && !val)` branch). Restore it
        // from what was actually saved on the trip, since it doesn't depend on water-source status.
        const startRestored = targetStart && !this.payload.start
        if (startRestored) {
          this.payload.start = targetStart
        }

        if (targetGarageId && this.garageOptions.some((g) => String(g.value) === targetGarageId)) {
          this.payload.garage = targetGarageId
        }

        console.log('[SFMS-1516][prefillZoneAndGarage] end:', {
          tripId: this.tripID,
          waterSourceRestored,
          startRestored,
          finalWaterSource: this.payload.waterSource,
          finalStart: this.payload.start,
        })
      } catch (err) {
        console.error('Prefill failed:', err)
      } finally {
        setTimeout(() => {
          this.isPrefilling = false
        }, 100)
      }
    },
    toggleLocationPicker(title, field) {
      this.location_title = title
      this.location_field = field
      this.show_picker = !this.show_picker
      if (this.show_picker) this.$bvModal.show('location-picker-modal')
      else this.$bvModal.hide('location-picker-modal')
    },
    async setValue(val, field) {
      if (field === 'waterSource') {
        console.log('[SFMS-1516][setValue] waterSource change-value received:', {
          tripId: this.tripID,
          val,
          previousPayloadWaterSource: this.payload.waterSource,
          previousPayloadStart: this.payload.start,
        })
      }

      this.payload[field] = val?._id || val

      if (field === 'waterSource' && val) {
        const waterSourceOptions = this.waterSourceOptions

        const waterSource = waterSourceOptions.find((each) => each.value === (val?._id || val))

        if (waterSource && waterSource.garageLocation) {
          this.payload.start = {
            location: waterSource.garageLocation.location,
            name: waterSource.garageLocation.name,
          }
        }
      } else if (field === 'waterSource' && !val) {
        console.log(
          '[SFMS-1516][setValue] waterSource is falsy -> clearing payload.start (pickup location)',
          { tripId: this.tripID }
        )
        this.payload.start = null
      }
    },
    setTimeOnDate(date, timeString) {
      if (!date || !timeString) return null
      const [hours, minutes, seconds] = timeString.split(':').map(Number)
      const updatedDate = new Date(date)
      updatedDate.setHours(hours, minutes, seconds || 0, 0)
      return updatedDate
    },
    checkIsPickupInBranch(service) {
      let obj = {
        branchID: this.payload?.reservation?.branch?._id,
        pickupLocation: service,
      }
      branchService.post(obj, 'is-pickup-point-exists-in-branch-zone').then(({ isExists }) => {
        if (!isExists) {
          this.error = this.$t('pickup-location-not-in-branch')
          this.payload.error_location = true
        } else {
          this.error = null
          this.payload.error_location = null
        }
      })
    },
  },
  computed: {
    labelText() {
      const isLocationPermitted = !this.$store.getters['enums/is_not_permitted'](
        'editTripLocationByOperator'
      )
      const isDatePermitted = !this.$store.getters['enums/is_not_permitted'](
        'editTripDateAndTimeByOperator'
      )

      if (isLocationPermitted && isDatePermitted) {
        return this.$t('location-and-dates')
      } else if (isLocationPermitted) {
        return this.$t('location')
      } else if (isDatePermitted) {
        return this.$t('dates')
      }
    },
    waterSourceOptions() {
      return this.waterSources || []
    },

    waterSourceDisabled() {
      return (
        this.status === 'Trip-Started' ||
        this.status === 'Booking-Cancelled' ||
        this.status === 'Booking-Cancelled-Note'
      )
    },
    toDateRules() {
      if (
        !this.payload.from_date ||
        !this.payload.from_time ||
        !this.payload.to_date ||
        !this.payload.to_time
      ) {
        return { required: true }
      }

      return {
        required: true,
        max_hour_difference: {
          from: this.setTimeOnDate(this.payload.from_date, this.payload.from_time),
          to: this.setTimeOnDate(this.payload.to_date, this.payload.to_time),
          hours: 24,
        },
      }
    },
  },
  watch: {
    garageOptions(newOptions) {
      if (!this.payload?.garage) return

      const garageId = String(this.payload.garage)

      if (newOptions.some((g) => String(g.value) === garageId)) {
        this.payload.garage = garageId
      }
    },

    waterSources: {
      immediate: true,
      handler(list) {
        const id = this.payload?.waterSource?._id || this.payload?.waterSource

        console.log('[SFMS-1516][watch:waterSources] list changed:', {
          tripId: this.tripID,
          currentPayloadWaterSourceId: id,
          listIds: (list || []).map((w) => w.value),
        })

        if (!id) return

        const exists = list.find((w) => String(w.value) === String(id))

        console.log('[SFMS-1516][watch:waterSources] restore check:', {
          tripId: this.tripID,
          id,
          existsInList: !!exists,
        })

        if (exists) {
          this.payload.waterSource = String(id)
        }
      },
    },

    'payload.start': {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        console.log('[SFMS-1516][watch:payload.start] pickup location changed:', {
          tripId: this.tripID,
          oldVal,
          newVal,
        })
      },
    },

    'payload.branch': {
      immediate: true,
      handler(newVal, oldVal) {
        if (this.isPrefilling) return
        if (!newVal) return

        // Only run on first load OR real branch change
        if (!oldVal) {
          this.prefillZoneAndGarage()
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.block {
  background: var(--color-01);
  border: 1px solid var(--color-14);
  box-shadow: 0px 12px 16px var(--color-38);
  border-radius: 4px;
  padding: 1rem 2rem;

  .title {
    font-weight: 700;
    font-size: 16px;
    color: var(--color-09);
    margin-bottom: 1.5rem;
  }

  .label {
    font-size: 14px;
    color: var(--color-02);
  }

  .value {
    font-weight: 700;
    font-size: 14px;
    color: var(--color-17);
  }

  .error {
    font-weight: 700;
    font-size: 14px;
    color: var(--color-47);
  }
}

.trip-title {
  font-weight: 700;
  font-size: 16px;
  color: var(--color-17);
}

.location-prefix {
  position: absolute;
  top: 33px;
  left: 10px;
}
</style>
